import { useEffect, useState } from 'react';
import moment from 'moment';
import CommonListTable, { CommonListColumn } from '../Common/CommonListTable';
import VendorPayoutService from '../../services/VendorPayoutService';

interface InputProps {
    cookId: number;
}

const vendorPayoutService = new VendorPayoutService();

const COLUMNS: CommonListColumn[] = [
    { label: 'Transaction ID', field: 'id' },
    { label: 'Description', render: (row) => row?.comments ?? '-' },
    { label: 'Payout Type', render: (row) => row?.type ?? '-' },
    { label: 'Year & Month', render: (row) => row?.yearAndMonth ?? '-' },
    { label: 'Amount', render: (row) => row?.amount ?? '-' },
    { label: 'Status', field: 'status', type: 'status' },
    {
        label: 'Status Updated At',
        nowrap: true,
        render: (row) => (row?.updatedAt ? moment(row.updatedAt).format('YYYY/MM/DD, HH:MM') : '-'),
    },
];

const CookVendorPayoutTab = ({ cookId }: InputProps) => {
    const [data, setData] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        vendorPayoutService
            .cookModuleYearlyTransaction(cookId, moment().format('YYYY'))
            .then((res: any) => {
                const flat = Array.isArray(res)
                    ? res.flatMap((element: any) => element?.data ?? [])
                    : [];
                setData(flat);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [cookId]);

    return (
        <CommonListTable
            columns={COLUMNS}
            data={data}
            loading={loading}
            emptyText="No Vendor Payout Found"
        />
    );
};

export default CookVendorPayoutTab;
